// A stage form is nested inside the main record form. Merge just the committed
// stage fields and generated PDFs, preserving unrelated unsaved outer inputs.
export function mergeWorkflowRecordValues(draft, savedRecord, updatedPaths = []) {
    const keys = new Set(['currentStatus', 'vetLetter', 'pregnancyReport'])
    updatedPaths.forEach(path => {
        if (typeof path === 'string' && path.startsWith('values.')) keys.add(path.slice(7))
    })
    const values = { ...(draft.values || {}) }
    Object.entries(savedRecord?.values || {}).forEach(([key, value]) => {
        if (keys.has(key)) values[key] = value
    })
    return { ...draft, values }
}
